"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextRow = exports.Text = exports.Icon = exports.Container = exports.ButtonsRow = exports.ButtonStyled = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Cross = _interopRequireDefault(require("../Icon/Icons/Cross"));
var _Button = _interopRequireDefault(require("../Button/Button"));
var _colors = require("../style/colors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Container = exports.Container = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__Container",
  componentId: "bufferapp-ui__sc-1umjdub-0"
})(["background:", ";box-shadow:0px 2px 5px rgba(0,0,0,0.5);border-radius:4px;position:absolute;width:327px;right:15px;top:15px;color:", ";z-index:999999;transition-duration:0.35s;transition-property:opacity,top;transition-timing-function:cubic-bezier(0.86,0,0.07,1);display:flex;flex-direction:column;"], _colors.grayDarker, _colors.white);
const TextRow = exports.TextRow = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__TextRow",
  componentId: "bufferapp-ui__sc-1umjdub-1"
})(["padding:16px;"]);
const ButtonsRow = exports.ButtonsRow = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__ButtonsRow",
  componentId: "bufferapp-ui__sc-1umjdub-2"
})(["background:", ";padding-right:10px;height:49px;display:flex;align-items:center;justify-content:flex-end;"], _colors.grayDark);
const ButtonStyled = exports.ButtonStyled = /*#__PURE__*/(0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "style__ButtonStyled",
  componentId: "bufferapp-ui__sc-1umjdub-3"
})(["color:", ";:focus{box-shadow:none;}:hover{color:", ";}"], _colors.grayLight, _colors.white);
const Text = exports.Text = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__Text",
  componentId: "bufferapp-ui__sc-1umjdub-4"
})(["font-family:Roboto,serif;font-style:normal;font-weight:normal;line-height:19px;font-size:14px;margin-right:20px;"]);
const Icon = exports.Icon = /*#__PURE__*/(0, _styledComponents.default)(_Cross.default).withConfig({
  displayName: "style__Icon",
  componentId: "bufferapp-ui__sc-1umjdub-5"
})(["position:absolute;font-size:16px;top:18px;right:19px;cursor:pointer;color:", ";:hover{color:", ";}"], _colors.grayLight, _colors.white);